import { requestDataHelper } from './helper';
import { get as baseGet, post as basePost } from './request';
import { getMetaInfo } from './utils';

function get(url, { param, config = {} }) {
  return requestDataHelper(baseGet, url, {
    param: param,
    config,
  });
}

function post(url, { param, config = {} }) {
  return requestDataHelper(basePost, url, param, config);
}

export { get, post, getMetaInfo };
